<div class="row" *ngIf="isBasica || isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                      <div class="row pt-3">
                        <div class="col-lg col-md col-xs col-sm col-xl text-right">
                            <button mat-flat-button color="primary" class="btnSize" matTooltip="Adicionar"
                                (click)="addItem()">
                                <i class="fa fa-plus fa-1x btnIcon"></i> Adicionar Lote DS
                            </button>
                            <button mat-flat-button color="primary" class="btnSize" matTooltip="Remover"
                                (click)="removeItem()" [disabled]="disabledBtnRemove" >
                                <i class="fa fa-minus fa-1x btnIcon"></i> Remover
                            </button>
                        </div>
                    </div>

                    </div>
                    <ng-template #viewContainerRef></ng-template>
                    <div class="row pt-3">

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ordem DS</mat-label>
                                <input matInput id="txtOrdemDs" #txtOrdemDs maxlength="20" formControlName="Ordem_ds"
                                    appOnlyNumber>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtOrdemDs.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Ordem_ds)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                          <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                              floatLabel="{{formFieldFloatLabel}}">
                              <mat-label class="InputLabelColor">Peso Debulha Total</mat-label>
                              <input matInput id="txtpeso_debulha_kg_total" #txtpeso_debulha_kg_total maxlength="20" formControlName="peso_debulha_kg_total"
                              [options]="{ thousands: '.', decimal: ',', precision: 1 }"  currencyMask readonly class="InputBlockColor">
                                  <i matSuffix class="{{iconDisableField}}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                              </mat-hint>
                              <mat-hint align="end">{{txtpeso_debulha_kg_total.value.length}} / 20</mat-hint>
                              <mat-error>{{hasErrorFormControl(formulario.controls.peso_debulha_kg_total)}}
                              </mat-error>
                          </mat-form-field>
                      </div>

                    </div>

                    <div class="row pt-3">


                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Status Silo</mat-label>
                                <mat-select #txtStatusSilo formControlName="Status_silo" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterStatusSilo($event.target.value)">
                                    <mat-option *ngFor="let item of listStatusSilo" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Volume Calda (litros)</mat-label>
                                <input matInput id="txtVolCaldaLitros" #txtVolCaldaLitros maxlength="10"
                                    formControlName="Volume_calda_litros" currencyMask (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtVolCaldaLitros.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Volume_calda_litros)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Calda por Tonelada (L/Ton)</mat-label>
                                <input matInput id="txtCaldaTon" #txtCaldaTon maxlength="10"
                                    formControlName="Calda_por_tonelada_l_ton" currencyMask readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtCaldaTon.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Calda_por_tonelada_l_ton)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Concentração K-obiol (%)</mat-label>
                                <input matInput id="txtConcKObiol" #txtConcKObiol maxlength="5"
                                    formControlName="Concentracao_k_obiol" currencyMask (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtConcKObiol.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Concentracao_k_obiol)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Concentração Actellic (%)</mat-label>
                                <input matInput id="txtConcActel" #txtConcActel maxlength="5"
                                    formControlName="Concentracao_actellic" currencyMask (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtConcActel.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Concentracao_actellic)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">K-obiol (litros)</mat-label>
                                <input matInput id="txtKObiol" #txtKObiol maxlength="10"
                                    formControlName="K_obiol_litros" currencyMask readonly class="InputBlockColor"
                                    [options]="{ thousands: '.', decimal: ',', precision: 3 }">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtKObiol.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.K_obiol_litros)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Actellic (litros)</mat-label>
                                <input matInput id="txtActel" #txtActel maxlength="10" formControlName="Actellic_litros"
                                    currencyMask readonly class="InputBlockColor"
                                    [options]="{ thousands: '.', decimal: ',', precision: 3 }">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtActel.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Actellic_litros)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Check SAP RW</mat-label>
                                <mat-select #txtCheckSapRw formControlName="Check_sap_rw" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..." (keyup)="createFilterSapRw($event.target.value)">
                                    <mat-option *ngFor="let item of listOptionsSapRw" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <!-- <input matInput id="txtCheckSapRw" #txtCheckSapRw maxlength="20"
                                    formControlName="Check_sap_rw" [matAutocomplete]="auto20">
                                <mat-autocomplete #auto20="matAutocomplete">
                                    <mat-option *ngFor="let item of filteredOptionsSapRw | async" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-autocomplete> -->
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <!-- <mat-hint align="end">{{txtCheckSapRw.value.length}} / 20</mat-hint> -->
                                <mat-error>{{hasErrorFormControl(formulario.controls.Check_sap_rw)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Check SAP DS</mat-label>
                                <mat-select #txtCheckSapDs formControlName="Check_sap_ds" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..." (keyup)="createFilterSapDs($event.target.value)">
                                    <mat-option *ngFor="let item of listOptionsSapDs" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <!-- <input matInput id="txtCheckSapDs" #txtCheckSapDs maxlength="20"
                                    formControlName="Check_sap_ds" [matAutocomplete]="auto21">
                                <mat-autocomplete #auto21="matAutocomplete">
                                    <mat-option *ngFor="let item of filteredOptionsSapDs | async" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-autocomplete> -->
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <!-- <mat-hint align="end">{{txtCheckSapDs.value.length}} / 20</mat-hint> -->
                                <mat-error>{{hasErrorFormControl(formulario.controls.Check_sap_ds)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Check SAP Químicos</mat-label>
                                <mat-select #txtCheckSapQuim formControlName="Check_sap_quimicos"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterSapQuimicos($event.target.value)">
                                    <mat-option *ngFor="let item of listOptionsSapQuimicos" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <!-- <input matInput id="txtCheckSapQuim" #txtCheckSapQuim maxlength="20"
                                    formControlName="Check_sap_quimicos" [matAutocomplete]="auto22">
                                <mat-autocomplete #auto22="matAutocomplete">
                                    <mat-option *ngFor="let item of filteredOptionsSapQuimicos | async"
                                        [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-autocomplete> -->
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <!-- <mat-hint align="end">{{txtCheckSapQuim.value.length}} / 20</mat-hint> -->
                                <mat-error>{{hasErrorFormControl(formulario.controls.Check_sap_quimicos)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>


                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>
